<template>
  <div class="min-h-screen flex flex-col">
    <!-- 导航栏 -->
    <Navbar />
    
    <!-- 页面内容 -->
    <main class="flex-grow">
      <router-view />
    </main>
    
    <!-- 页脚 -->
    <Footer />
    <SideFloat />
  </div>
</template>

<script setup>
import Navbar from './components/Navbar.vue'
import Footer from './components/Footer.vue'
import SideFloat from './components/SideFloat.vue'
</script>